<label class="col-md-4 control-label">{{label}}
	<i class="fa fa-question-circle margin-left-xs"
			revTooltip
			[allowHtml]="true"
			[tooltipContent]="tooltip">
	</i>
</label>
